import { getPartnerId, getToken, getUserId } from "../lib/localStorage";
import { sha256 } from "../lib/mainData";

export const getAuthHeaders = async (payload: any) => {
  const token = getToken();
  const userId = getUserId();
  const partnerId = getPartnerId();
  const { REACT_APP_SECRET_KEY } = process.env;
  return {
    Authorization: token ? `Bearer ${token}` : "",
    userId: userId || "",
    partnerId: partnerId || "",
    signature: sha256(payload + userId + partnerId + REACT_APP_SECRET_KEY),
  };
};

export const getNonAuthHeaders = async (payload: any) => {
  const { REACT_APP_SECRET_KEY } = process.env;
  return {
    signature: sha256(payload + REACT_APP_SECRET_KEY),
  };
};
